import useAppStore from '$appStore'
import { RangeFilter } from '$constants'
import dayjs, { Dayjs } from 'dayjs'

/**
 * Gets the date range depending on query string params or if it doesn't have query
 * string params then it gets the values from the AppStore
 * @param queryParams Query string values from the URL
 * @returns startDateTime: Dayjs, endDateTime: Dayjs
 */
export function getDateRangeFromQueryStringOrAppStore(queryParams: {
  [key: string]: string
}) {
  const { start, end, dateRange, prevDateRange } = queryParams

  let startDateTime: Dayjs
  let endDateTime: Dayjs

  if (queryParams.start && queryParams.end && queryParams.dateRange) {
    startDateTime = dayjs(start)
    endDateTime = dayjs(end)
    const range = dateRange as RangeFilter
    const prevRange = prevDateRange as RangeFilter

    const {
      reportsMetadata: {
        startDateTime: storedStartDateTime,
        endDateTime: storedEndDateTime,
        dateRange: storedRange,
        prevDateRange: storedPrevRange,
      },
    } = useAppStore.getState()

    if (
      !storedEndDateTime.isSame(endDateTime) ||
      !storedStartDateTime.isSame(startDateTime) ||
      storedRange === range ||
      storedPrevRange === prevRange
    ) {
      useAppStore.setState({
        reportsMetadata: {
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          dateRange: range,
          prevDateRange: prevRange,
        },
      })
    }
  } else {
    const {
      reportsMetadata: {
        startDateTime: storedStartDateTime,
        endDateTime: storedEndDateTime,
      },
    } = useAppStore.getState()

    startDateTime = storedStartDateTime
    endDateTime = storedEndDateTime
  }

  return { startDateTime, endDateTime }
}
